var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogin = function SvgLogin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon/login")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "acac-login",
    transform: "translate(-564.000000, -388.000000)",
    fill: "#7D7F7B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/mobile/login",
    transform: "translate(564.000000, 388.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49987968,0 C10.0140373,0 12.0516663,2.03777491 12.0516663,4.55178665 C12.0516663,5.95644083 11.4155605,7.21242368 10.4156424,8.04736543 C13.0733417,8.89109689 15.0001604,11.3796352 15.0001604,14.3181745 C15.0001604,14.6947363 14.6948968,15 14.318335,15 C13.9417731,15 13.6365095,14.6947363 13.6365095,14.3181745 C13.6365095,11.4946335 11.3923154,9.19518132 8.59051169,9.10609229 L8.42174783,9.10341287 L6.57801153,9.10341287 C3.69820025,9.10341287 1.36365095,11.4380719 1.36365095,14.3181745 C1.36365095,14.6947363 1.05838729,15 0.681825474,15 C0.305263663,15 0,14.6947363 0,14.3181745 C0,11.379447 1.92677787,8.89084412 4.58587517,8.04683165 C3.58470952,7.21320031 2.94809303,5.95683898 2.94809303,4.55178665 C2.94809303,2.03790251 4.98599554,0 7.49987968,0 Z M7.49987968,1.36365095 C5.73911916,1.36365095 4.31174398,2.79102614 4.31174398,4.55178665 C4.31174398,6.31254716 5.73911916,7.73992235 7.49987968,7.73992235 C9.26089182,7.73992235 10.6880154,6.31269662 10.6880154,4.55178665 C10.6880154,2.79087668 9.26089182,1.36365095 7.49987968,1.36365095 Z",
    id: "Stroke-1"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/login.c527a127.svg";
export { ForwardRef as ReactComponent };